const ccThemeRole = Shopify.theme.role ?? 'unknown';
if (!localStorage.getItem('cc-settings-loaded') || localStorage.getItem('cc-settings-loaded') !== ccThemeRole) {
  fetch('https://check.cleancanvas.co.uk/', {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    method: 'POST',
    mode: 'cors',
    body: new URLSearchParams({
      shop: Shopify.shop,
      theme: theme.info?.name ?? '',
      version: theme.info?.version ?? '',
      role: ccThemeRole,
      contact: document.querySelector('script[src*=theme-editor][data-contact]')?.dataset.contact
    })
  })
    .then((response) => {
      if (response.ok) {
        localStorage.setItem('cc-settings-loaded', ccThemeRole);
      }
    });
}

document.addEventListener('shopify:section:load', (evt) => {
  // Load and evaluate section specific scripts immediately.
  evt.target.querySelectorAll('script[src]').forEach((script) => {
    const s = document.createElement('script');
    s.src = script.src;
    document.body.appendChild(s);
  });

  // If loaded section is a pop-up, open it.
  if (evt.target.matches('.cc-pop-up')) {
    customElements.whenDefined('pop-up').then(() => {
      evt.target.querySelector('pop-up').open();
    });
  }
});

document.addEventListener('shopify:block:select', (evt) => {
  // If selected block is a slideshow slide, show it and pause autoplay (if enabled).
  if (evt.target.matches('.slideshow__slide')) {
    const slideshow = evt.target.closest('slide-show');

    setTimeout(() => {
      slideshow.setActiveSlide(Number(evt.target.dataset.index));
      slideshow.pauseAutoplay();
    }, 200);
  }

  // If selected block is a slider item, scroll to it.
  if (evt.target.matches('.slider__item')) {
    const carousel = evt.target.closest('carousel-slider');
    if (!carousel.slider) return;

    carousel.slider.scrollTo({
      left: carousel.slides[Array.from(carousel.slides).indexOf(evt.target)].offsetLeft,
      behavior: 'smooth'
    });
  }
});

document.addEventListener('shopify:block:deselect', (evt) => {
  // If deselected block is a slideshow slide, resume autoplay (if enabled).
  if (evt.target.matches('.slideshow__slide')) {
    const slideshow = evt.target.closest('slide-show');

    setTimeout(() => {
      slideshow.resumeAutoplay();
    }, 200);
  }
});

// Debug out custom events
const customEvents = [
  'on:cart:add',
  'on:variant:change',
  'on:line-item:change',
  'on:cart:error',
  'on:cart-drawer:before-open',
  'on:cart-drawer:after-open',
  'on:cart-drawer:after-close',
  'on:quickbuy:before-open',
  'on:quickbuy:after-open',
  'on:quickbuy:after-close',
  'dispatch:cart-drawer:open',
  'dispatch:cart-drawer:refresh',
  'dispatch:cart-drawer:close'
];
customEvents.forEach((event) => {
  document.addEventListener(event, (evt) => {
    if (event.includes('dispatch:cart-drawer') && theme.settings.cartType !== 'drawer') {
      // eslint-disable-next-line
      console.warn(
        'Enterprise Theme: The Cart Drawer is not enabled. To enable it, change Theme Settings > Cart > Cart type.'
      );
    } else {
      // eslint-disable-next-line
      console.info(
        '%cTheme event triggered',
        'background: #000; color: #bada55',
        event,
        evt.detail
      );
    }
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.getElementById('allProductsToggle');
  const panel = document.getElementById('allProductsPanel');
  const closeBtn = document.getElementById('closeAllProducts');
  const backBtn = document.getElementById('menuBackBtn');
  const titleEl = document.getElementById('menuTitle');

  if (!toggle || !panel) return;

  // History stack for multi-level back navigation
  let history = [];

  const showMenu = (name, label, pushHistory = true) => {
    const current = panel.querySelector('.menu-list.active');
    if (pushHistory && current) {
      history.push({ menu: current.dataset.menu, label: titleEl.textContent });
    }

    panel.querySelectorAll('.menu-list').forEach(m => m.classList.remove('active'));
    const target = panel.querySelector(`[data-menu="${name}"]`);
    if (target) target.classList.add('active');

    if (name === 'level-1') {
      titleEl.textContent = 'All Products';
      titleEl.classList.remove('hidden');
      backBtn.classList.add('hidden');
      history = [];
    } else {
      titleEl.textContent = '';
      titleEl.classList.add('hidden');
      backBtn.classList.remove('hidden');
    }
  };

  if (window.innerWidth <= 1024) {
    return; // Mobile: handled separately
  }

  toggle.addEventListener('click', () => {
    panel.classList.add('active');
    document.body.classList.add('overflow-hidden');
    showMenu('level-1', 'All Products', false);
  });

  closeBtn.addEventListener('click', () => {
    panel.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    history = [];
  });

  backBtn.addEventListener('click', () => {
    if (history.length > 0) {
      const prev = history.pop();
      showMenu(prev.menu, prev.label, false);
    } else {
      showMenu('level-1', 'All Products', false);
    }
  });

  panel.addEventListener('click', (e) => {
    const link = e.target.closest('.menu-link[data-target]');
    if (!link) return;
    const label = link.dataset.label || link.childNodes[0].textContent.trim();
    showMenu(link.dataset.target, label);
  });
});